export class SentExternalLaboratoryDocument {
    SentExternalLaboratoryId: number;
    Base64File: string;
    DocumentName: string;
}